import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notification__update-item__initiator" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "notification__item-deleted__action" }, "deleted Item", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_NotificationTemplate = _resolveComponent("NotificationTemplate")!

  return (_openBlock(), _createBlock(_component_NotificationTemplate, {
    notification: _ctx.notification,
    class: "notification__item-deleted"
  }, {
    pic: _withCtx(() => [
      _createVNode(_component_Avatar, {
        src: _ctx.notification.initiatorAvatarSrc || null,
        gap: _ctx.notification.getInitials()
      }, null, 8, ["src", "gap"])
    ]),
    title: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "large",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "400"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.notification.initiatorFullName), 1),
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.locationPreposition) + " " + _toDisplayString(_ctx.notification.deletedLocation), 1)
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BaseSubHeading, {
        size: "medium",
        color: "monochrome-06",
        darkColor: "monochrome-03",
        weight: "500",
        className: "notification__item-content notification__item-deleted__content"
      }, {
        default: _withCtx(() => [
          (_ctx.itemTypeName)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["notification__item-deleted__type", _ctx.itemTypeClass])
              }, _toDisplayString(_ctx.itemTypeName), 3))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.notification.itemSequenceNumber) + " ", 1),
          _createVNode(_component_BaseSubHeading, {
            size: "medium",
            color: "monochrome-06",
            darkColor: "monochrome-03",
            weight: "400",
            class: "notification__item-content__title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.notification.getItemValue("title")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["notification"]))
}